/**
 * Alias notification detail settings: which sender / conversation / channel /
 * Space details message notifications reveal. Stored server-side per alias via
 * `SpacePreferencesProvider`; outside it (public shell) everything resolves to
 * the built-in defaults and saving is unavailable.
 */

import { useMemo } from 'react';
import { DEFAULT_NOTIFICATION_DISPLAY, type NotificationDisplaySettings } from '@adieuu/shared';
import { useOptionalSpacePreferences } from './useSpacePreferences';

export interface NotificationDisplaySettingsValue {
  /** False outside the authenticated shell; the setter is a no-op then. */
  available: boolean;
  display: NotificationDisplaySettings;
  setDisplay: (display: NotificationDisplaySettings) => Promise<void>;
}

const noop = async () => {};

export function useNotificationDisplaySettings(): NotificationDisplaySettingsValue {
  const prefs = useOptionalSpacePreferences();
  const display = prefs?.notificationDisplay ?? DEFAULT_NOTIFICATION_DISPLAY;
  const setDisplay = prefs?.setNotificationDisplay ?? noop;
  return useMemo(
    () => ({ available: prefs !== null, display, setDisplay }),
    [prefs, display, setDisplay],
  );
}
